import { isEmpty } from 'lodash';
import { getReservationsByProductType } from '.';

/*
  If just one ferry -> simple
  If more than two ferries -> complex
  If two ferries, one to island and one from island -> simple
     A -> B, C -> A or A -> B, B -> C
*/
export const isComplexBookingFromQT = (booking) => {
  const ferryReservations = getReservationsByProductType('ferry', booking);
  if (ferryReservations.length <= 1) {
    return false;
  }
  if (ferryReservations.length > 2) {
    return true;
  }

  const [departure, destination] = ferryReservations;
  const {
    from_route_stop_attributes: { stop_id: departureBegin },
    to_route_stop_attributes: { stop_id: departureEnd },
  } = departure;
  const {
    from_route_stop_attributes: { stop_id: destinationBegin },
    to_route_stop_attributes: { stop_id: destinationEnd },
  } = destination;

  return departureBegin !== destinationEnd && departureEnd !== destinationBegin;
};

export const isSimpleBooking = (booking, allowedVehicleTypes) => {
  const { vehicles_attributes = [], reservations_attributes } = booking;

  const notAllowedVehicleType = vehicles_attributes.find(
    (vehicle) => !allowedVehicleTypes.includes(vehicle.vehicle_type_id)
  );
  if (notAllowedVehicleType) {
    return false;
  }

  /*
     The booking is NOT 'Simple' when
     1, There is reservation other than ferry
     2, Reservation count is more than 2
     3, It is the kind of booking from QT console where
        there is no definition of departure and return
   */
  if (
    isEmpty(reservations_attributes) ||
    reservations_attributes.length > 2 ||
    getReservationsByProductType('ferry', booking).length !==
      reservations_attributes.length ||
    isComplexBookingFromQT(booking)
  ) {
    return false;
  }

  return true;
};

export const hasReservation = (booking) =>
  !isEmpty(booking) &&
  booking.reservations_attributes &&
  booking.reservations_attributes.length !== 0;

export const receiptPagePath = (bookingId) =>
  `/bookings/checkout/receipt/${bookingId}`;

export const isBookingFromSysAdmin = (booking) =>
  booking?.creator?.name === 'Sys Admin';

/*
  Extract booking ID from URL for the 1SLK tenant.
  /kangaroo-island/bookings/12345/ferry/services/departure -> 12345
  /kangaroo-island/bookings/ferry/services/departure -> undefined
*/
export const getBookingIdFromUrl = () => {
  const result = window.location.pathname.match(/\/bookings\/([0-9]+)/);

  return result ? result[1] : undefined;
};

export const isOptionExtraEnabled = () =>
  Boolean(
    ecom.craftConfig.bookingPreferences?.optionalExtras?.optionalExtras?.length
  );
